
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './ElementSelected.scss'

const ElementSelected = ({ items, children, className, isLink, enableRemove, enableInfo, linkCallback, removeItemCallback, infoCallback }) => {
  const classContainer = classNames('itemList-container', className, {
    'itemList-container_read-only': !enableRemove
  })

  const classElement = classNames('elemento-selezionato', className, {
    'is-link': isLink
  })

  return (
    <div className={classContainer}>
      <ul className='itemList'>
        {items.map((item, index) =>
          <li className={classElement} key={item.id} onClick={() => linkCallback(item.id)}>
            {item.text}
            {enableInfo && !item.remomeInfoForThisItems && <a onClick={() => infoCallback(item.id)} className='filterInfo'>i</a>}
            {enableRemove && !item.remomeBtnRemoveForThisItems && <a onClick={() => removeItemCallback(item.id)} className='elemento-selezionato-close-link' />}
          </li>
        )}
        <li className='d-inline-block p-bottom-thin'>{children}</li>
      </ul>
    </div>
  )
}

ElementSelected.defaultProps = {
  isLink: false
}

ElementSelected.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string,
  enableRemove: PropTypes.bool
}

export default ElementSelected
